import { createSlice } from '@reduxjs/toolkit';
import { getResultMethods } from 'ducks/result-methods-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type ResultMethodsListState = ReturnType<typeof normalizeLookups<'result_method_name', 'result_method_id'>>;

const initialState: ResultMethodsListState = [];

const resultMethodsListSlice = createSlice({
  name: Slices.RESULT_METHODS_LIST,
  initialState,
  reducers: {
    clearResultMethodsList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getResultMethods.pending, () => {
        return initialState;
      })
      .addCase(getResultMethods.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'result_method_name', 'result_method_id');
      })
      .addCase(getResultMethods.rejected, () => {
        return initialState;
      });
  },
});

export const { clearResultMethodsList } = resultMethodsListSlice.actions;

export default resultMethodsListSlice.reducer;
